import AddCompanyContainer from 'modules/companies/containers/AddCompanyContainer';

const AddCompanyView = () => <AddCompanyContainer />;

export default AddCompanyView;
